import React from 'react';
interface ButtonProps {
  variant?: 'primary' | 'secondary' | 'accent' | 'white' | 'transparent-white';
  children: React.ReactNode;
  className?: string;
  href?: string;
  onClick?: () => void;
}
const BOOKING_URL = 'https://api.leadconnectorhq.com/widget/booking/VHdKXbV72iB8LTpEH0sJ';
export function Button({
  variant = 'primary',
  children,
  className = '',
  href = BOOKING_URL,
  onClick
}: ButtonProps) {
  const baseStyles = 'font-heading text-[14px] font-medium px-[28px] py-[14px] rounded-[6px] transition-colors duration-300 inline-flex items-center justify-center text-center';
  const variants = {
    primary: 'bg-navy text-white hover:bg-navy-dark',
    secondary: 'bg-transparent border-[1.5px] border-navy text-navy hover:bg-warm-gray',
    accent: 'bg-gold text-white hover:bg-gold-dark',
    white: 'bg-white text-navy hover:bg-warm-gray',
    'transparent-white': 'bg-white/10 border-[2px] border-white/60 text-white hover:bg-white/20 hover:border-white backdrop-blur-sm'
  };
  return <a href={href} className={`${baseStyles} ${variants[variant]} ${className}`} onClick={onClick} data-id="element-49">
      {children}
    </a>;
}